var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "details-view tab-warning",
      staticStyle: { height: "600px !important" }
    },
    [
      _c(
        "cargo-left-right-resize",
        {
          ref: "cargoLeftRightResize",
          staticStyle: { "min-height": "90%" },
          attrs: {
            "left-style": { "max-width": "190px" },
            "right-style": { overflow: "hidden" }
          }
        },
        [
          _c("template", { slot: "left" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                { staticStyle: { margin: "6px 0px 0px 10px" } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      filterable: "",
                      cache: false,
                      "tag-name": "templateName",
                      "tag-value": "uuid",
                      "filter-tag-names": ["templateName"],
                      "filter-type": "global",
                      "default-value": _vm.filter.trackingTemplateUuid,
                      "static-options": _vm.trackingTemplates,
                      placeholder: _vm.$t(
                        "CargoMsg.Cargo_PleaseSelectAnSOPTemplate"
                      )
                    },
                    on: { parentCallBack: _vm.changeTrackingTemplate }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    staticClass: "section",
                    attrs: {
                      "grid-options": _vm.leftGridOptions,
                      "row-data": _vm.leftRowData,
                      "show-side-bar": false,
                      "min-height": "100%",
                      "grid-style":
                        "min-width: 240px;width:100%;height:90%;min-height:496px"
                    },
                    on: {
                      gridReady: function(p) {
                        _vm.gridApi = p.api
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c("div", { staticClass: "operations" }, [
                _c(
                  "div",
                  { staticStyle: { margin: "6px" } },
                  [
                    _c(
                      "span",
                      {
                        class: _vm.showDayWarningClass,
                        on: { click: _vm.changeShowDayWarning }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DayWarning")))]
                    ),
                    _c(
                      "span",
                      {
                        class: _vm.onlyShowNodeClass,
                        on: { click: _vm.changeOnlyShowNode }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_OnlyDataNodesAreDisplayed")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "refresh", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.fetchData("init")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Refresh")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "moreFilter", type: "primary" },
                        on: { click: _vm.moreFilter }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MoreFilters")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showDealBtn,
                            expression: "showDealBtn"
                          }
                        ],
                        attrs: { no: "handled", type: "success" },
                        on: {
                          click: function($event) {
                            return _vm.onHandled(2)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Handled")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showDealBtn,
                            expression: "showDealBtn"
                          }
                        ],
                        attrs: { no: "ignoreMessage", type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.onHandled(1)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Sop.ignoreMessage")))]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "config-module": "11003",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData,
                      "grid-style": "width:100%;height:90%;min-height:496px"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c(
        "div",
        {
          staticStyle: {
            "min-height": "30px",
            height: "100%",
            position: "relative"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { position: "absolute", right: "5px" } },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "11003",
                  total: _vm.filter.total || 0,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.onPage
                }
              })
            ],
            1
          )
        ]
      ),
      _c("more-filter-dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.filterDialog.visible,
            expression: "filterDialog.visible"
          }
        ],
        ref: "filterDialog",
        attrs: {
          visible: _vm.filterDialog.visible,
          "alert-types": _vm.alertTypes,
          "sop-templates": _vm.trackingTemplates,
          lob: _vm.lob
        },
        on: {
          close: function($event) {
            _vm.filterDialog.visible = false
          },
          search: _vm.handleSearch,
          changeDate: function($event) {
            _vm.showDayWarning = false
          },
          changeTrackingTemplateKey: _vm.changeTrackingTemplateKey
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }